var map = {
	"./bg-clip.png": "2d001",
	"./icon-discharge.svg": "5033",
	"./icon-itch.svg": "b3e2",
	"./icon-odor.svg": "982a",
	"./logo-symptomchecker.png": "b8eb",
	"./logo-symptomchecker.svg": "38f3",
	"./logo.png": "cf05",
	"./product-coolingcloths.jpg": "fb0f",
	"./product-cure.jpg": "69be",
	"./product-instantitchrelief.jpg": "54e8",
	"./product-stayfreshgel.jpg": "6667"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";